import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectRouteBoardId } from '../router/router.selectors';
import { MigrationStatusState } from './migration-status.types';

export const selectMigrationStatusState = createFeatureSelector<MigrationStatusState>('migrationStatus');

export const selectActiveBoardMigrationStatus = createSelector(
  selectRouteBoardId,
  selectMigrationStatusState,
  (boardId, migrationStatusState) => ({ boardId, migrationStatus: migrationStatusState?.[<string>boardId] })
);

export const selectActiveBoardMigrationInProgress = createSelector(
  selectActiveBoardMigrationStatus,
  ({ migrationStatus }) => migrationStatus?.inProgress
);
